interface Config {
  API_BASE_URL: string | undefined;
  COGNITO: {
    REGION: string | undefined;
    USER_POOL_ID: string | undefined;
    CLIENT_ID: string | undefined;
  };
  STORAGE_KEYS: {
    JWT_TOKEN: string;
    USER_DATA: string;
    TENANT_ID: string;
    TENANT_META: string;
    FORCE_LOGOUT: string;
  };
  ENDPOINTS: {
    AUTH: {
      LOGIN: string;
      REGISTER: string;
      RESOLVE_TENANT: string;
    };
  };
  REQUEST_TIMEOUT: number;
}

const config: Config = {
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,

  COGNITO: {
    REGION: import.meta.env.VITE_COGNITO_REGION,
    USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID,
  },

  STORAGE_KEYS: {
    JWT_TOKEN: "jwtToken",
    USER_DATA: "user",
    TENANT_ID: "tenantId",
    TENANT_META: "tenantMeta",
    FORCE_LOGOUT: "mira_force_logout",
  },

  // API Endpoints
  ENDPOINTS: {
    AUTH: {
      LOGIN: "/auth/login",
      REGISTER: "/auth/sign-up",
      RESOLVE_TENANT: "/platform/tenant/resolve",
    },
  },

  // Request Timeout (in milliseconds)
  REQUEST_TIMEOUT: 30000,
};

export default config;
